// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cellMuted[data-v-a208ac6a]{color:var(--link-ink-secondary)}.footerInfo[data-v-a208ac6a]{display:flex;justify-content:space-between;align-items:center}", ""]);
// Exports
module.exports = exports;
